import styled from "styled-components";
import PropTypes from "prop-types";
import { withTheme } from "@material-ui/styles";

const ImageBanner = withTheme(styled.div`
  background-color: ${props => props.backgroundColor};
  background: ${({ backgroundColor }) => backgroundColor}
    url(${({ src }) => src}) no-repeat bottom;
  background-size: cover;
`);

ImageBanner.propTypes = {
  backgroundColor: PropTypes.string,
  height: PropTypes.number.isRequired,
  src: PropTypes.string
};

ImageBanner.defaultProps = {
  backgroundColor: "#000000"
};

export default ImageBanner;
